import { Form } from "@vwfs-bronson/bronson-react";
import { PersonalData } from "../components/personal-information/PersonalData";
import { ComunicationType } from "../components/personal-information/ComunicationType";
import { WizardButtons } from "../components/ui/WizardButtons";
import { Formik } from "formik";
import * as Yup from "yup";
import { useMatchMakerWizard } from "../hooks/useMatchMakerWizard";
import { useTranslation } from "react-i18next";
import { ContactOptionEnum, IPersonalData, Step, SubmitAnswersRequest } from "../interfaces";
import { PhoneCountryCodeType } from "@bus/models";
import { FocusError } from "../components/generic/FocusError";
import TlsCheckService from "../services/TlsCheckService";
const regExFirstName = new RegExp(
    "^[a-zA-ZÄÅáâäàãåÉéêëèíîïìÖóôöòõÜúüûùÇçÑñŠšßẞ]{1}[a-zA-ZÄÅáâäàãåÉéêëèíîïìÖóôöòõÜúüûùÇçÑñŠš ß()./\\-'‘]*$"
);
const regExLastName = new RegExp(
    "^[a-zA-ZÄÅáâäàãåÉéêëèíîïìÖóôöòõÜúüûùÇçÑñŠšßẞ]{1}[a-zA-ZÄÅáâäàãåÉéêëèíîïìÖóôöòõÜúüûùÇçÑñŠš ß()./\\-'‘]*$"
);
const regExPhoneNumber = new RegExp("^[0123456789]*$");
const regExEmail = new RegExp(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);

const TLS_ERROR_NAME = "TLS_ERROR"

export const PersonalInformationPage = () => {
    const { t } = useTranslation("errormessages");

    const { submitAnswersRequest, setSubmitAnswersRequest, isEdit } = useMatchMakerWizard();
    const { contactDetails: personalData } = submitAnswersRequest;

    const SignupSchema = Yup.object().shape({
        firstName: Yup.string()
            .min(2, t("errormessages:2"))
            .max(35, t("errormessages:3"))
            .matches(regExFirstName, t("errormessages:4"))
            .required(t("errormessages:1")),
        lastName: Yup.string()
            .min(2, t("errormessages:2"))
            .max(35, t("errormessages:3"))
            .matches(regExLastName, t("errormessages:4"))
            .required(t("errormessages:1")),
        mobilePhoneNumber: Yup.string()
            .min(2, t("errormessages:2"))
            .max(20, t("errormessages:3"))
            .matches(regExPhoneNumber, t("errormessages:4"))
            .required(t("errormessages:1")),
        email: Yup.string()
            .matches(regExEmail, t("errormessages:4"))
            .email(t("errormessages:1"))
            .required(t("errormessages:1"))
            .email(t("errormessages:4")),
        contactPreference: Yup.string().required(t("errormessages:1")).oneOf(Object.keys(ContactOptionEnum)),
    });

    const checkTls = async (email: string) => {
    const tlsCheckService = new TlsCheckService()

    const response = await tlsCheckService.checkTls({
        email,
    })

    return response
}

    return (
        <>
            <Formik
                initialValues={
                    {
                        firstName: personalData?.firstName ?? "",
                        lastName: personalData?.lastName ?? "",
                        mobilePhoneCountryCode: personalData?.mobilePhoneCountryCode ?? PhoneCountryCodeType.Italy,
                        mobilePhoneNumber: personalData?.mobilePhoneNumber ?? "",
                        email: personalData?.email ?? "",
                        contactPreference: personalData?.contactPreference ?? undefined,
                    } as IPersonalData
                }
                validationSchema={SignupSchema}
                enableReinitialize={true}
                onSubmit={async (values, { setFieldError }) => {
                    const response = await checkTls(values.email)
                    if (!response.data.tlsSupported) {
                        setFieldError("email", TLS_ERROR_NAME);
                        return;
                    }

                    setSubmitAnswersRequest((value) => {
                        return {
                            ...value,
                            contactDetails: values as IPersonalData,
                            isEditMode: isEdit,
                            currentStep: Step.CONTACT_DETAILS,
                        } as SubmitAnswersRequest;
                    });
                }}
            >
                {(formikProps) => (
                    <Form id="PersonalInformationForm" onSubmit={formikProps.handleSubmit} noValidate>
                        <div className="u-mb-large">
                            <PersonalData />
                            <ComunicationType />
                            <FocusError />
                        </div>
                        <WizardButtons />
                    </Form>
                )}
            </Formik>
        </>
    );
};
